/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Socket } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { SocketsService } from './sockets.service';
import {
  joinRoom,
  joinRoomResponse,
  leaveChat,
  sendMessage,
} from '../models/chat.model';

@Injectable({
  providedIn: 'root',
})
export class chatSocketService {
  private joinRoomResponse$ = new Subject<joinRoomResponse>();
  constructor(private _SocketsService: SocketsService) {}

  private get socket(): Socket {
    return this._SocketsService.socket;
  }

  receiverMessage(): Observable<any> {
    return new Observable<any>(observer => {
      if (this.socket) {
        const handler = (data: any) => {
          observer.next(data);
        };
        this.socket.on('receive-message', handler);

        return () => {
          this.socket.off('receive-message', handler);
        };
      }

      return undefined;
    });
  }

  /**
   * Emits whenever the socket (re)connects. The socket instance is reused
   * across socket.io auto-reconnects, so the `connect` event fires on every
   * successful (re)connection. Consumers can use this to re-join their room.
   */
  onReconnect(): Observable<void> {
    return new Observable<void>(observer => {
      const socket = this.socket;
      if (!socket) {
        return undefined;
      }

      const handler = (): void => observer.next();
      socket.on('connect', handler);

      return () => {
        socket.off('connect', handler);
      };
    });
  }

  joinRoom(body: joinRoom): void {
    if (this.socket) {
      this.socket.emit('join-chat', body, (response: joinRoomResponse) => {
        this.joinRoomResponse$.next(response);
      });
    } else {
      console.warn('Socket not initialized, cannot join room');
    }
  }

  getJoinRoomResponse(): Observable<joinRoomResponse> {
    return this.joinRoomResponse$.asObservable();
  }

  sendMessage(body: sendMessage): void {
    if (this.socket) {
      this.socket.emit('send-message', body);
    } else {
      console.warn('Socket not initialized, cannot send message');
    }
  }

  leaveChat(body: leaveChat): void {
    if (this.socket) {
      this.socket.emit('leave-chat', body);
    }
  }
}
